export default __webpack_public_path__ + "static/media/product-image-hover-9.f8ca0758.jpg";